import type { Entity } from '@core/types';
import { omit } from 'lodash';
import type { EntityRelationKey } from '../enum';

export const createKeyRemover =
  <T extends Entity>(keys: EntityRelationKey[]) =>
  (entity: T): T =>
    omit(entity, keys) as T;
